import Vue from 'vue';
import Vuex from 'vuex';

import DirectProduct from '@/modules/DirectProductStore.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: false,
    errorMessage: '',
    loading: false
  },
  mutations: {
    startLoading(state){
      state.loading = true;
    },
    endLoading(state){
      state.loading = false;
    },
    visibleMessageError(state, message){
      state.error = true;
      state.errorMessage = message;
    },
    hideMessageError(state){
      state.error = false;
      state.errorMessage = '';
    },
  },
  actions: {
    startLoading({commit}){
      return new Promise((resolve) => {
        commit('startLoading');
        resolve();
      })
    },
    endLoading({commit}){
      return new Promise((resolve) => {
        commit('endLoading');
        resolve();
      })
    },
    setMessageError({commit}, errorMessage){
      return new Promise((resolve) => {
        commit('visibleMessageError', errorMessage);
        resolve();
      })
    },
    hideMessageError({commit}){
      return new Promise((resolve) => {
        commit('hideMessageError');
        resolve();
      })
    },
  },
  modules: {
    DirectProduct
  },
  getters: {
    loadingActive: state => state.loading,
  }
})
